import OapCountdown from './code/Scripts/components/OapCountdown';

export default {
  components: {
    OapCountdown,
  },
};
